import axios from 'axios'

export type SafetyInformationSource = {
  id: string
  name: string
  url: string
  description: string
  logoUrl: string
  appliedFilter: string
  country: {
    name: string
    code: string
    flagUrl: string
  }
}

export async function getSafetyInformationSources(): Promise<
  SafetyInformationSource[]
> {
  const { data } = await axios.get('/safety-information/sources')
  return data
}
